
export const ACCESS_TOKEN = 'token'
export const USER_TYPE = 'userInfo'

export const USER_TOKEN = 'userToken'
export const APP_TOKEN = 'appToken'

